import { makeStyles, colors } from '@cuda-networks/bds-core'

export default makeStyles(theme => ({
  tabs: {
    height: theme.spacing(3)
  },
  titleContainer: {
    marginTop: theme.spacing(1),
    height: theme.spacing(7),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${colors.scaleGray300}`
  },
  title: {
    color: colors.scaleGray900
  },
  subtitle: {
    color: colors.scaleGray600
  },
  helpIcon: {
    cursor: 'pointer',
    marginLeft: theme.spacing(0.5),
    width: theme.spacing(2.5),
    marginTop: theme.spacing(0.25),
    color: colors.blue600
  }
}))
